import { Component, HostBinding, Input, SecurityContext } from '@angular/core';
import { SafeStyle, DomSanitizer } from '@angular/platform-browser';
import {SvgIcon} from '@valg-shared/utils/svg-icon';

@Component({
  selector: 'valg-card',
  templateUrl: './card.component.html'
})
export class CardComponent{
  @Input() height?: string;
  @Input() custom = false;
  @HostBinding('class.card--border') @Input() border = false;
  @HostBinding() class = "card";
  @HostBinding('style') 
  get style(): SafeStyle {
    if(this.height){
      let style = this.sanitizer.sanitize(SecurityContext.STYLE, '--card-height:'+ this.height);
      if(style){
        return style;
      }
    }
    return '--card-height:auto';
  }

  readonly SvgIcon = SvgIcon;

  constructor(private sanitizer: DomSanitizer){ }
}
